import { VolumetricFlowCalculatorInput } from 'src/modules/user-input/calcVolumetricFlow/types.ts';
import { CalcKindEnum, RegionsEnum } from 'src/generated/operations.ts';
import { calcCvKv } from 'src/modules/user-input/calcVolumetricFlow/calcCvKv.ts';
import { convert } from 'src/modules/user-input/convert.ts';
import { getUnitByName } from 'src/modules/user-input/getUnitByName.ts';
import { Units } from 'uom-units';
import { Psi } from 'src/utils/Psi.ts';
import { targetUnits, targetUnitsAm } from 'src/modules/user-input/targetUnits.ts';
import { calcCvSteam } from 'src/modules/user-input/calcVolumetricFlow/calcCvSteam.ts';
import { calcKvsSteam } from 'src/modules/user-input/calcVolumetricFlow/calcKvsSteam.ts';

export const getCalculatedCvKv = (
    input: VolumetricFlowCalculatorInput,
    kind: CalcKindEnum,
    isModulating: boolean,
    currentRegion: RegionsEnum,
): string => {
    switch (kind) {
        case CalcKindEnum.Kvs: {
            if (currentRegion === RegionsEnum.Am) {
                const cv = calcCvKv(
                    convert(
                        input.v100,
                        getUnitByName(input.v100_u, Units.GallonsPerMinute),
                        Units.GallonsPerMinute,
                    ),
                    convert(
                        input.maxDp,
                        getUnitByName(input.maxDp_u, Psi),
                        Psi,
                    ),
                );
                return convert(
                    cv,
                    Units.GallonsPerMinute,
                    getUnitByName(input.kvs_u, targetUnitsAm.volumetricFlow),
                );
            }
            const kvs = calcCvKv(
                convert(
                    input.v100,
                    getUnitByName(input.v100_u, Units.CubicMeterPerHour),
                    Units.CubicMeterPerHour,
                ),
                convert(
                    input.maxDp,
                    getUnitByName(input.maxDp_u, Units.Bar),
                    Units.Bar,
                ),
            );
            return convert(
                kvs,
                Units.CubicMeterPerHour,
                getUnitByName(input.kvs_u, targetUnits.volumetricFlow),
            );
        }
        case CalcKindEnum.Steam: {
            if (currentRegion === RegionsEnum.Am) {
                return convert(
                    calcCvSteam(
                        convert(
                            input.mass,
                            getUnitByName(input.mass_u, targetUnitsAm.massVolumetricFlow),
                            targetUnitsAm.massVolumetricFlow,
                        ),
                        convert(
                            input.inlet,
                            getUnitByName(input.inlet_u, targetUnitsAm.inletOutlet),
                            targetUnitsAm.inletOutlet,
                        ),
                        isModulating,
                    ),
                    targetUnitsAm.volumetricFlow,
                    getUnitByName(input.kvs_u, targetUnitsAm.volumetricFlow),
                );
            }
            return convert(
                calcKvsSteam(
                    convert(
                        input.mass,
                        getUnitByName(input.mass_u, targetUnits.massVolumetricFlow),
                        targetUnits.massVolumetricFlow,
                    ),
                    convert(
                        input.inlet,
                        getUnitByName(input.inlet_u, targetUnits.inletOutlet),
                        targetUnits.inletOutlet,
                    ),
                    convert(
                        input.outlet,
                        getUnitByName(input.outlet_u, targetUnits.inletOutlet),
                        targetUnits.inletOutlet,
                    ),
                ),
                targetUnits.volumetricFlow,
                getUnitByName(input.kvs_u, targetUnits.volumetricFlow),
            );
        }
        default:
            return '';
    }
};
